import React from 'react';

import Icon from 'dpl/common/components/Icon';
import Logo from 'dpl/components/Logo';

// The logo's own svg is `mw-100 max-h-100` against a 460x106 viewBox, so it
// takes its size from this container, the way `shared/_thin_header` does.
const LOGO_WIDTH = 96;

interface SimilarBreedsSeeAllHeaderProps {
  breedName: string;
  onReturnClick: () => void;
}

/**
 * The overlay's fixed header: the logo, and the control back to the search the
 * visitor came from.
 */
export default function SimilarBreedsSeeAllHeader({
  breedName,
  onReturnClick
}: SimilarBreedsSeeAllHeaderProps) {
  return (
    // `sticky` rather than `fixed`: the overlay's own wrapper is the scroll
    // container and it spans the viewport, so this pins exactly where a fixed
    // header would - and the content below does not have to reserve a hardcoded
    // header height to sit clear of it.
    <header className="SimilarBreedsSeeAllHeader sticky top-0 z-999 bg-sand">
      <div className="flex flex-column gap-12 ph5 pv4">
        <a
          className="db primary"
          href="/"
          aria-label="Homepage"
          style={{ width: LOGO_WIDTH }}
        >
          <Logo />
        </a>
        <button
          className="flex items-center gap-8 mr-auto"
          data-test-id="similar_breeds_see_all_return_button"
          onClick={onReturnClick}
          type="button"
        >
          <Icon
            className="tertiary"
            name="fetch-back"
            height="24px"
            width="24px"
          />
          <span className="font-16 lh-title secondary">
            Return to <span className="fw-medium underline">{breedName}</span>
          </span>
        </button>
      </div>
    </header>
  );
}
